import React, { useState } from 'react';
import { ChevronLeft as SelectIcon } from '@td-client-frontend/icons';
import clsx from 'clsx';
import { trackEvent } from '../api/piwik/piwikService';
import { PiwikCategory, PiwikAction, PiwikName } from '../@types/common';

export function SideMenu({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSideMenu = () => {
    trackEvent({
      category: PiwikCategory.BUTTONS,
      action: PiwikAction.CLICKED,
      name: PiwikName.SEARCH_HIDE
    });
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="flex flex-col self-stretch h-auto max-h-screen transition-all duration-150"
      style={{ minWidth: '400px', marginLeft: !isOpen ? '-360px' : '0px' }}
      aria-expanded={isOpen}
    >
      <div className="flex flex-1 bg-gray-10 px-6 pb-8 pt-2 relative">
        <div className="flex flex-col  w-full" hidden={!isOpen} id="side-menu">
          {children}
        </div>
        <button
          className="absolute top-1 right-0 w-6 z-20 cursor-pointer focus:outline-none focus-visible:ring"
          onClick={toggleSideMenu}
          aria-label={isOpen ? 'Close Search Panel' : 'Open Search Panel'}
          aria-controls="side-menu"
          aria-expanded={isOpen}
        >
          <span className={clsx(!isOpen && 'rotate-180', 'duration-200 transform block')}>
            <SelectIcon className="w-5 h-5" />
          </span>
        </button>
      </div>
    </div>
  );
}
